"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppPromo = exports.appPromoContext = exports.AppPromoProvider = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _useCookieStoreInfo = require("../../hooks/useCookieStoreInfo");
var _useMobileOs = require("../../hooks/useMobileOs");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const appPromoContext = exports.appPromoContext = /*#__PURE__*/(0, _react.createContext)({});
const {
  Provider
} = appPromoContext;
const AppPromoProvider = ({
  children
}) => {
  const [visible, setVisible] = (0, _react.useState)(false);
  const [pagePath, setPagePath] = (0, _react.useState)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    owner: store
  } = (0, _useCookieStoreInfo.useCookieStoreInfo)();
  const {
    userOs
  } = (0, _useMobileOs.useMobileOs)();
  (0, _react.useEffect)(() => {
    setPagePath(window.location.pathname);
  }, []);
  const {
    data
  } = (0, _staticApiClientReact.useGetTenantMobileAppSmartAppBanner)(tenant, userOs ?? 'Android', {
    lang: language,
    pagePath: pagePath ?? '',
    storeName: store ?? undefined
  }, {
    swr: {
      enabled: Boolean(userOs && pagePath),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false
    }
  });
  (0, _react.useEffect)(() => {
    setVisible((0, _utils.isAppPromoBannerVisible)({
      data,
      userOs
    }));
  }, [data, userOs]);
  const onClose = (0, _react.useCallback)(() => {
    setVisible(false);
    (0, _utils.setHideAppPromoBannerUntilDate)();
  }, []);
  const value = (0, _react.useMemo)(() => ({
    appDescription: data?.appDescription,
    appIcon: data?.appIcon,
    appName: data?.appName,
    bannerLink: data?.bannerLink,
    onClose,
    visible
  }), [data?.appDescription, data?.appIcon, data?.appName, data?.bannerLink, onClose, visible]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.AppPromoProvider = AppPromoProvider;
const useAppPromo = () => (0, _react.useContext)(appPromoContext);
exports.useAppPromo = useAppPromo;
